const easeOut = [0.25, 0.46, 0.45, 0.94] as const

// The site's signature entrance curve (hero, event modal)
export const EASE_OUT_QUINT = [0.22, 1, 0.36, 1] as const

export const fadeInUp = {
	initial: { opacity: 0, y: 14 },
	animate: {
		opacity: 1,
		y: 0,
		transition: { duration: 0.9, ease: easeOut },
	},
}

export const fadeIn = {
	initial: { opacity: 0 },
	animate: {
		opacity: 1,
		transition: { duration: 0.7, ease: easeOut, delay: 0.3 },
	},
}

export const staggerContainer = {
	initial: {},
	animate: {
		transition: {
			staggerChildren: 0.15,
			delayChildren: 0.1,
		},
	},
}

export const staggerItem = {
	initial: { opacity: 0, y: 14 },
	animate: {
		opacity: 1,
		y: 0,
		transition: { duration: 0.9, ease: easeOut },
	},
}
